export default class Locale_Report {
	ReportName: string = "Report name";
	ReportEmbedUrl: string = "Report embed url";
	OpenNewTab: string = "Open in new tab/window";
	SelectReportToViewAvailability: string = "Select on which views this report is available";
	UserType: string = "User types";
}